// GENERATED by robot-comms/tools/gen-contract.ts from robot-comms asyncapi.yaml.
// Do not edit by hand — run `npm run gen-contract`.

export interface Channel {
  name: string;
  address: string; // template, e.g. "robots/{robotId}/cmd/velocity" or "fleet/robots"
  operatorAction: "send" | "receive";
  consumer: "operator" | "service"; // who receives it (service = trusted-side, not the browser)
  qos: number;
  retain: boolean;
  contentType: string;
  binary: boolean;
  operationLevel: string;
  perRobot: boolean;
}

export const CHANNELS = [
  {
    "name": "cmdVelocity",
    "address": "robots/{robotId}/cmd/velocity",
    "operatorAction": "send",
    "consumer": "operator",
    "qos": 0,
    "retain": false,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "low",
    "perRobot": true
  },
  {
    "name": "cmdAction",
    "address": "robots/{robotId}/cmd/action",
    "operatorAction": "send",
    "consumer": "operator",
    "qos": 1,
    "retain": false,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "high",
    "perRobot": true
  },
  {
    "name": "telemetryVelocityApplied",
    "address": "robots/{robotId}/telemetry/velocity_applied",
    "operatorAction": "receive",
    "consumer": "operator",
    "qos": 0,
    "retain": false,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "",
    "perRobot": true
  },
  {
    "name": "telemetryJoints",
    "address": "robots/{robotId}/telemetry/joints",
    "operatorAction": "receive",
    "consumer": "operator",
    "qos": 0,
    "retain": false,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "",
    "perRobot": true
  },
  {
    "name": "telemetryPose",
    "address": "robots/{robotId}/telemetry/pose",
    "operatorAction": "receive",
    "consumer": "operator",
    "qos": 0,
    "retain": false,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "",
    "perRobot": true
  },
  {
    "name": "telemetryVideo",
    "address": "robots/{robotId}/telemetry/video",
    "operatorAction": "receive",
    "consumer": "operator",
    "qos": 0,
    "retain": false,
    "contentType": "application/octet-stream",
    "binary": true,
    "operationLevel": "",
    "perRobot": true
  },
  {
    "name": "telemetryVideoMeta",
    "address": "robots/{robotId}/telemetry/video/meta",
    "operatorAction": "receive",
    "consumer": "operator",
    "qos": 0,
    "retain": true,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "",
    "perRobot": true
  },
  {
    "name": "telemetryStream",
    "address": "robots/{robotId}/telemetry/stream",
    "operatorAction": "receive",
    "consumer": "operator",
    "qos": 1,
    "retain": true,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "",
    "perRobot": true
  },
  {
    "name": "telemetryVendorRaw",
    "address": "robots/{robotId}/telemetry/vendor_raw",
    "operatorAction": "receive",
    "consumer": "operator",
    "qos": 0,
    "retain": false,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "",
    "perRobot": true
  },
  {
    "name": "telemetryBattery",
    "address": "robots/{robotId}/telemetry/battery",
    "operatorAction": "receive",
    "consumer": "operator",
    "qos": 0,
    "retain": true,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "",
    "perRobot": true
  },
  {
    "name": "statusHeartbeat",
    "address": "robots/{robotId}/status/heartbeat",
    "operatorAction": "receive",
    "consumer": "operator",
    "qos": 0,
    "retain": false,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "",
    "perRobot": true
  },
  {
    "name": "statusOnline",
    "address": "robots/{robotId}/status/online",
    "operatorAction": "receive",
    "consumer": "operator",
    "qos": 1,
    "retain": true,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "",
    "perRobot": true
  },
  {
    "name": "alarmAnomaly",
    "address": "robots/{robotId}/alarm/anomaly",
    "operatorAction": "receive",
    "consumer": "operator",
    "qos": 1,
    "retain": false,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "",
    "perRobot": true
  },
  {
    "name": "cmdMission",
    "address": "robots/{robotId}/cmd/mission",
    "operatorAction": "send",
    "consumer": "operator",
    "qos": 1,
    "retain": false,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "high",
    "perRobot": true
  },
  {
    "name": "cmdTuning",
    "address": "robots/{robotId}/cmd/tuning",
    "operatorAction": "send",
    "consumer": "operator",
    "qos": 1,
    "retain": false,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "high",
    "perRobot": true
  },
  {
    "name": "statusTuning",
    "address": "robots/{robotId}/status/tuning",
    "operatorAction": "receive",
    "consumer": "operator",
    "qos": 1,
    "retain": true,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "",
    "perRobot": true
  },
  {
    "name": "telemetryDiag",
    "address": "robots/{robotId}/telemetry/diag",
    "operatorAction": "receive",
    "consumer": "operator",
    "qos": 0,
    "retain": false,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "",
    "perRobot": true
  },
  {
    "name": "telemetryMap",
    "address": "robots/{robotId}/telemetry/map",
    "operatorAction": "receive",
    "consumer": "operator",
    "qos": 0,
    "retain": true,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "",
    "perRobot": true
  },
  {
    "name": "telemetryMapGrid",
    "address": "robots/{robotId}/telemetry/map_grid",
    "operatorAction": "receive",
    "consumer": "service",
    "qos": 0,
    "retain": true,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "",
    "perRobot": true
  },
  {
    "name": "telemetryCostmap",
    "address": "robots/{robotId}/telemetry/costmap",
    "operatorAction": "receive",
    "consumer": "operator",
    "qos": 0,
    "retain": false,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "",
    "perRobot": true
  },
  {
    "name": "telemetryPatrol",
    "address": "robots/{robotId}/telemetry/patrol",
    "operatorAction": "receive",
    "consumer": "operator",
    "qos": 0,
    "retain": false,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "",
    "perRobot": true
  },
  {
    "name": "statusPatrol",
    "address": "robots/{robotId}/status/patrol",
    "operatorAction": "receive",
    "consumer": "operator",
    "qos": 1,
    "retain": true,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "",
    "perRobot": true
  },
  {
    "name": "telemetryMotionDebug",
    "address": "robots/{robotId}/telemetry/motion_debug",
    "operatorAction": "receive",
    "consumer": "operator",
    "qos": 0,
    "retain": false,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "",
    "perRobot": true
  },
  {
    "name": "statusMode",
    "address": "robots/{robotId}/status/mode",
    "operatorAction": "receive",
    "consumer": "operator",
    "qos": 1,
    "retain": true,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "",
    "perRobot": true
  },
  {
    "name": "statusEnvironment",
    "address": "robots/{robotId}/status/environment",
    "operatorAction": "receive",
    "consumer": "operator",
    "qos": 1,
    "retain": true,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "",
    "perRobot": true
  },
  {
    "name": "telemetryCommand",
    "address": "robots/{robotId}/telemetry/command",
    "operatorAction": "receive",
    "consumer": "operator",
    "qos": 1,
    "retain": false,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "",
    "perRobot": true
  },
  {
    "name": "statusCapabilities",
    "address": "robots/{robotId}/status/capabilities",
    "operatorAction": "receive",
    "consumer": "operator",
    "qos": 1,
    "retain": true,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "",
    "perRobot": true
  },
  {
    "name": "statusPermitted",
    "address": "robots/{robotId}/status/permitted",
    "operatorAction": "receive",
    "consumer": "operator",
    "qos": 1,
    "retain": true,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "",
    "perRobot": true
  },
  {
    "name": "telemetryLocalization",
    "address": "robots/{robotId}/telemetry/localization",
    "operatorAction": "receive",
    "consumer": "operator",
    "qos": 0,
    "retain": false,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "",
    "perRobot": true
  },
  {
    "name": "cmdPoll",
    "address": "robots/{robotId}/cmd/poll",
    "operatorAction": "send",
    "consumer": "operator",
    "qos": 1,
    "retain": false,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "low",
    "perRobot": true
  },
  {
    "name": "alarmFault",
    "address": "robots/{robotId}/alarm/fault",
    "operatorAction": "receive",
    "consumer": "operator",
    "qos": 1,
    "retain": false,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "",
    "perRobot": true
  },
  {
    "name": "telemetryTaskLog",
    "address": "robots/{robotId}/telemetry/task_log",
    "operatorAction": "receive",
    "consumer": "operator",
    "qos": 1,
    "retain": false,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "",
    "perRobot": true
  },
  {
    "name": "cmdList",
    "address": "cmd/list",
    "operatorAction": "send",
    "consumer": "operator",
    "qos": 1,
    "retain": false,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "low",
    "perRobot": false
  },
  {
    "name": "fleetRobots",
    "address": "fleet/robots",
    "operatorAction": "receive",
    "consumer": "operator",
    "qos": 1,
    "retain": true,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "",
    "perRobot": false
  },
  {
    "name": "cmdDebugQuery",
    "address": "cmd/debug_query",
    "operatorAction": "send",
    "consumer": "operator",
    "qos": 1,
    "retain": false,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "low",
    "perRobot": false
  },
  {
    "name": "fleetDebugResult",
    "address": "fleet/debug_result",
    "operatorAction": "receive",
    "consumer": "operator",
    "qos": 1,
    "retain": false,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "",
    "perRobot": false
  },
  {
    "name": "fleetDebugManifest",
    "address": "fleet/debug_manifest",
    "operatorAction": "receive",
    "consumer": "operator",
    "qos": 1,
    "retain": true,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "",
    "perRobot": false
  },
  {
    "name": "fleetDebugCache",
    "address": "fleet/debug_cache/{entryId}",
    "operatorAction": "receive",
    "consumer": "operator",
    "qos": 1,
    "retain": true,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "",
    "perRobot": false
  },
  {
    "name": "fleetRaw",
    "address": "fleet/raw",
    "operatorAction": "receive",
    "consumer": "operator",
    "qos": 0,
    "retain": false,
    "contentType": "application/json",
    "binary": false,
    "operationLevel": "",
    "perRobot": false
  }
] as const satisfies readonly Channel[];

export type ChannelName = (typeof CHANNELS)[number]["name"];
